import Header from "../components/header.jsx";
import Sidebar from "../components/sidebar.jsx";
import ActiveCustomer from "../components/activecustomer.jsx";
import Footer from "../components/footer.jsx";

function ActiveCustomerpage() {
    return (
        <div>
        <div className='wrapper'>
          <Header />
          <Sidebar /> 
          <ActiveCustomer/> 
        </div>
        <Footer /> 
      </div>
      // <Login/>
      );
}
export default ActiveCustomerpage;
